import { SurveyVersion, Survey } from '../../models';
import { BaseDataService } from './BaseDataService';
import { NotificationService } from '../../services';

export class SurveyVersionDataService extends BaseDataService<SurveyVersion> {
    constructor(notificationService: NotificationService) {
        super('SurveyVersion', 'SurveyVersions', notificationService);
    }

    getActive(survey: Survey) {
        const endpoint = `${this.endpointRoot}/active/${survey.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyVersionViewModel
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    getAllBySurvey(survey: Survey) {
        const endpoint = `${this.endpointRoot}/bysurvey/${survey.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyVersionViewModel
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    publish(surveyVersion: SurveyVersion) {
        const endpoint = `${this.endpointRoot}/publish/${surveyVersion.id}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyVersionViewModel
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    clone(surveyVersion: SurveyVersion) {
        const endpoint = `${this.endpointRoot}/clone/${surveyVersion.id}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyVersionViewModel
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    copy(surveyVersion: SurveyVersion) {
        const endpoint = `${this.endpointRoot}/copy/${surveyVersion.id}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyVersionViewModel
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    setActive(surveyVersion: SurveyVersion) {
        const endpoint = `${this.endpointRoot}/setActive/${surveyVersion.id}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyVersionViewModel
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    unlock(surveyVersion: SurveyVersion) {
        const endpoint = `${this.endpointRoot}/unlock/${surveyVersion.id}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyVersionViewModel
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    unlockClear(surveyVersion: SurveyVersion) {
        const endpoint = `${this.endpointRoot}/unlockClear/${surveyVersion.id}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyVersionViewModel
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/api/SurveyVersionData.tsx